import React from 'react';
import PropTypes from 'prop-types';
import AudioMessage from './components/AudioMessage';

const AUDIO_EXTENSIONS = new Set(['mp3', 'ogg', 'wav']);

const extractExtension = (value = '') => {
  if (!value) {
    return '';
  }

  const normalized = value.toLowerCase();
  const match = normalized.match(/\.([a-z0-9]+)(?:$|[?#])/);
  return match ? match[1] : '';
};

const isAudioFile = ({ type, filename, url }) => {
  if (type === 'audio') {
    return true;
  }

  const filenameExt = extractExtension(filename);
  if (AUDIO_EXTENSIONS.has(filenameExt)) {
    return true;
  }

  const urlExt = extractExtension(url);
  return AUDIO_EXTENSIONS.has(urlExt);
};

const Message = ({
  type,
  thumbnail,
  media,
  text,
  url,
  filename,
}) => {
  const audioSrc = media || url;

  if (isAudioFile({ type, filename, url })) {
    return (
      <AudioMessage
        src={audioSrc}
        fallbackUrl={url}
        filename={filename}
      />
    );
  }

  switch (type) {
    case 'file':
      return (
        <p className="text-truncate_area">
          <a href={url} target="_blank" rel="noopener noreferrer">
            {filename}
          </a>
        </p>
      );
    case 'picture':
      return (
        <p className="text-truncate_area">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <div className="thumbnail" style={{ backgroundImage: `url(${thumbnail || url})` }} />
            {/* <img className="thumbnail" src={thumbnail || url} alt="" /> */}
          </a>
        </p>
      );
    case 'text':
    case undefined:
    case null:
    default:
      return (<p className="text-truncate_area">{text}</p>);
  }
};

Message.defaultProps = {
  type: 'text',
  thumbnail: null,
  media: null,
  text: '',
  url: '',
  filename: '',
};
Message.propTypes = {
  type: PropTypes.string,
  thumbnail: PropTypes.string,
  media: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
  filename: PropTypes.string,
};

export default Message;
